import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-down\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M19.53 8.47a.75.75 0 0 1 0 1.06l-6.293 6.293a1.75 1.75 0 0 1-2.474 0L4.47 9.53a.75.75 0 0 1 1.06-1.06l6.293 6.293a.25.25 0 0 0 .354 0L18.47 8.47a.75.75 0 0 1 1.06 0\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol